import * as _ from 'lodash';

import { isArray, isObject, isString } from 'util';

import * as SelectionActions from '../actions/selection';
import * as QueryActions from '../actions/query';
import * as TabsActions from '../../../xena-tabs/state-management/actions/tabs';

import { WijmoSortEvent } from '../../../../shared/models/wijmo-sort-event';
import { InitialState as InitialTabState } from '../../../xena-tabs/state-management/reducers/tabs';
import { Group } from '../../shared/models/groups/groups.model';


export interface StateObject {
	// TODO: rename selectedGroup to selctedGroups
	selectedGroup: Array<string>;
	selectedOffer: string;
	selectedOfferObject: Group;
	selectedRegions: Array<string>;
	tab: number;
	selected: boolean;
	offerGrouping: Array<string>;
	offerSorting: WijmoSortEvent;
	groupSorting: WijmoSortEvent;
	viewedGroups: Array<string>;
}

export type State = Array<StateObject>;

export const InitialState: State = [{
	selectedGroup: [],
	selectedOffer: '',
	selectedOfferObject: null,
	selectedRegions: [],
	tab: InitialTabState[0].id,
	selected: InitialTabState[0].selected,
	offerGrouping: [],
	offerSorting: null,
	groupSorting: null,
	viewedGroups: []
}];

type AllActions = SelectionActions.All|TabsActions.All|QueryActions.All;

export function reducer(state: State = InitialState, action: AllActions): State {
	switch (action.type) {

		case SelectionActions.SELECT_REGION:
			return state.map(stateObj => (
				{
					...stateObj,
					selectedRegions: (stateObj.selected ? action.payload : stateObj.selectedRegions),
					selectedGroup: (stateObj.selected ? [] : stateObj.selectedGroup),
					selectedOffer: (stateObj.selected ? '' : stateObj.selectedOffer),
					selectedOfferObject: (stateObj.selected ? null : stateObj.selectedOfferObject)
				}
			));

		case SelectionActions.SELECT_GROUP:
			action.payload = isArray(action.payload) ? action.payload : [];

			return state.map(stateObj => ({
				...stateObj,
				selectedGroup: (stateObj.selected ? action.payload.map(group => group.id) : stateObj.selectedGroup),
				selectedOffer: (stateObj.selected ? '' : stateObj.selectedOffer),
				selectedOfferObject: (stateObj.selected ? null : stateObj.selectedOfferObject),
				viewedGroups: (stateObj.selected ? _.uniq(stateObj.viewedGroups.concat(action.payload.map(group => group.id))) : stateObj.viewedGroups)
			}));

		case SelectionActions.SELECT_OFFER:
			return state.map(stateObj => ({
				...stateObj,
				selectedOffer: (stateObj.selected ? action.payload.id : stateObj.selectedOffer),
				selectedOfferObject: (stateObj.selected ? action.payload : stateObj.selectedOfferObject)
			}));

		case SelectionActions.GROUP_OFFERS_BY:
			return state.map(stateObj => ({...stateObj, offerGrouping: (stateObj.selected ? action.payload : stateObj.offerGrouping)}));

		case SelectionActions.SORT_OFFERS_BY:
			return state.map(stateObj => ({...stateObj, offerSorting: (stateObj.selected ? action.payload : stateObj.offerSorting)}));

		case SelectionActions.SORT_GROUPS_BY:
			return state.map(stateObj => ({...stateObj, groupSorting: (stateObj.selected ? action.payload : stateObj.groupSorting)}));

		case QueryActions.RESET_QUERY:
			return state.map(stateObj => {
				if (stateObj.selected) {
					return {
						...stateObj,
						selectedRegions: [],
						selectedGroup: [],
						selectedOffer: '',
						selectedOfferObject: null,
						offerGrouping: [],
						offerSorting: null,
						groupSorting: null,
						viewedGroups: []
					};
				}

				return stateObj;
			});

		case QueryActions.SUBMIT_QUERY:
			return state.map(stateObj => {
				if (stateObj.selected) {
					return {
						...stateObj,
						selectedRegions: [],
						selectedGroup: [],
						selectedOffer: '',
						selectedOfferObject: null
					};
				}

				return stateObj;
			});

		case SelectionActions.INIT_SELECTION_TABS:
			return action.payload.map((tab, index) => ({
				selectedGroup: state[index] && isArray(state[index].selectedGroup) ? state[index].selectedGroup : InitialState[0].selectedGroup,
				selectedOffer: state[index] && isString(state[index].selectedOffer) ? state[index].selectedOffer : InitialState[0].selectedOffer,
				selectedOfferObject: state[index] && isObject(state[index].selectedOfferObject) ? state[index].selectedOfferObject : InitialState[0].selectedOfferObject,
				selectedRegions: state[index] && isArray(state[index].selectedRegions) ? state[index].selectedRegions : InitialState[0].selectedRegions,
				offerGrouping: state[index] && isArray(state[index].offerGrouping) ? state[index].offerGrouping : null,
				offerSorting: state[index] && isObject(state[index].offerSorting) ? state[index].offerSorting : InitialState[0].offerSorting,
				groupSorting: state[index] && isObject(state[index].groupSorting) ? state[index].groupSorting : InitialState[0].groupSorting,
				viewedGroups: state[index] && isArray(state[index].viewedGroups) ? state[index].viewedGroups : InitialState[0].viewedGroups,
				tab: tab.id,
				selected: tab.selected
			}));

		case TabsActions.ADD_TAB:
			return state.concat({
				selectedGroup: [],
				selectedOffer: '',
				selectedOfferObject: null,
				selectedRegions: [],
				tab: action.payload.id,
				selected: false,
				offerGrouping: [],
				offerSorting: null,
				groupSorting: null,
				viewedGroups: []
			});

		case TabsActions.SELECT_TAB:
			return state.map(stateObj => ({...stateObj, selected: stateObj.tab === action.payload.id}));

		case TabsActions.REMOVE_TAB:
			if (state.length === 1) {
				return state;
			}

			const tabToRemove = state.find(stateObj => stateObj.tab === action.payload.id);
			const newState = state.filter(stateObj => stateObj.tab !== action.payload.id);

			if (tabToRemove.selected) {
				newState[0].selected = true;
			}

			return newState;

		default:
			return state;
	}
}

/**
 * helper selector functions
 */
export const GetSelectedRegions = (s: State): Array<string> => s.find(st => st.selected).selectedRegions;
export const GetSelectedGroup = (s: State): Array<string> => s.find(st => st.selected).selectedGroup;
export const GetSelectedOffer = (s: State): string => s.find(st => st.selected).selectedOffer;
export const GetTheRealSelectedOffer = (s: State): Group => s.find(st => st.selected).selectedOfferObject;
export const GetViewedGroups = (s: State): Array<string> => s.find(st => st.selected).viewedGroups;
export const GetOfferGroupBy = (s: State): Array<string> => s.find(st => st.selected).offerGrouping;
export const GetOfferSortBy = (s: State): WijmoSortEvent => s.find(st => st.selected).offerSorting;
export const GetGroupSortBy = (s: State): WijmoSortEvent => s.find(st => st.selected).groupSorting;
export const GetSelected = (s: State): StateObject => s.find(st => st.selected);



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/selection.ts